import React, { useState } from 'react';
import FloatingMessageBox from './FloatingMessageBox';

const FloatingMessageBoxWrapper = ({
  children,
  onClose,
  ariaLive = 'polite',
}) => {
  const [showBox, setShowBox] = useState(true);
  function close() {
    setShowBox(false);
    onClose();
  }
  return showBox ? (
    <FloatingMessageBox ariaLive={ariaLive} close={close}>
      {children}
    </FloatingMessageBox>
  ) : null;
};

export default FloatingMessageBoxWrapper;
